module.exports = __webpack_public_path__ + "static/hero_visas.0aff46bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/transaction-fees/hero_visas.png
// module id = 407
// module chunks = 114276838955818 223237999207604